import styled from '@emotion/styled';

export const TextButton = styled.span`
  color: ${props => props.theme.a.color};
  ${props =>
    props.disabled
      ? `
          cursor: default;
          text-decoration: none;
          `
      : `
          cursor: pointer;
          font-weight: 600;
          color: #0156F5;
          text-decoration: underline;

          &:hover {
            background-color: #d8edff;
          }

          `}
`;
